<template>
  <emd-tippy id="feedback" tag="button" :class="['emd-action-button', tippyClassList]"  :type="'action-button'" :content="'feedback'">
    <span :class="['emd-text', classList]">
      <i :class="`uil uil-${icon}`" fixed-width transform="width-14"></i>
    </span>
  </emd-tippy>
</template>

<script>
import EmdTippy from '../emdTippy/EmdTippy.vue'

export default {
  name: 'EmdActionButton',
  components: {
    EmdTippy
  },
  props: {
    tippy: {
      type: String,
      required: false,
      default: ''
    },
    color: {
      type: String,
      default: null,
      validator: (value) => {
        return ['primary', 'secondary', 'tertiary', 'success', 'danger', 'info', 'warning', 'subtle', null].indexOf(value) !== -1
      }
    },
    type: {
      type: String,
      default: '',
      required: false
    },
    icon: {
      type: String,
      default: '',
      required: true
    }
  },
  computed: {
    classList () {
      var classList = []
      if (this.type !== '') {
        classList.push(`_type_${this.type}`)
      }
      return classList
    },
    tippyClassList () {
      var classList = []
      if (this.color) {
        classList.push(`_color_${this.color}`)
      }
      if (this.tippy !== '') {
        classList.push('_has-tooltip')
      }
      return classList
    }
  }
}
</script>
